import React from "react";
import { Form, FormGroup, Label, Input, CustomInput, FormText, FormFeedback } from "reactstrap";

import AccountBanner from "../../components/AccountBanner"
import ActionButton from "../../components/ActionButton"
import LoadSpinner from "../../components/LoadSpinner";
import { getRequest, postRequest } from "sharedUtils/httpUtils";
import { getQueryStringParams } from "sharedUtils/navUtils"

import BrandTable from "../../components/Tables/BrandTable";
import Modal from 'react-modal';

Modal.setAppElement('#root');

class Brand extends React.Component {

    state = {
        filter: "",
        synchMerchantProductsCalled: false,
        sectors: [],
        filteredSectors: [],
        breadCrumbList: [
            { link: '/Admin', text: 'Admin' },
            { link: '/Admin/Brands', text: 'Merchant Partners' }
        ],
        merchant: {},
        mapmId: null,
        apmId: null,
        oldIntegratedDate: new Date().toISOString(),
        affiliateProgramManagers: [],
        isSaving: false,
        loading: true,
        show: false,
        showSynch: false,
        apmId: 0,
        logoUrlError: "",   // shows when non-data: input would exceed 255
    }

    logoInputRef = React.createRef();

    merchantName = "";

    componentDidMount = async () => {
        let scrollOptions = {
            left: 0,
            top: 0,
            behavior: 'auto'
        }
        window.scrollTo(scrollOptions);

        const mapm = getQueryStringParams(window.location.search).m;
        const apm = getQueryStringParams(window.location.search).a;

        if (mapm && apm && !isNaN(parseInt(mapm, 10)) && !isNaN(parseInt(apm,10))) {
            const mapmId = parseInt(mapm, 10);
            const apmId = parseInt(apm, 10);

            await new Promise((resolve) => {
                this.setState({
                    mapmId, apmId }, resolve); // Await setState completion
            });
            await this.populateData(mapmId, apm);  // Ensure this runs only after setState completes
        } else {
            await this.populateData();
        }

    }

    synchMerchantProducts = async () => {
        this.setState({ synchMerchantProductsCalled: true });
        await getRequest(`/api/Merchant/SynchMerchantProductsByMerchantId?merchantId=${this.props.match.params.id}`);
    }

    populateData = async (mapmId = null, apmId = null) => {
        var merchant = await getRequest(`/api/Merchant/GetMerchant/?id=${this.props.match.params.id}`);
        if (merchant && merchant.hasOwnProperty('homepage') && !!(merchant.homepage?.trim()) && merchant.homepage.startsWith("https://")) {
            merchant.homepage = merchant.homepage.substring("https://".length);
        }

        this.setState({ merchant, oldIntegratedDate: merchant.integratedDate });

        let breadCrumbList = "";

        if (mapmId && apmId) {
            breadCrumbList = [
                { link: '/Admin', text: 'Admin' },
                { link: '/Admin/AffiliateNetworks', text: 'Affiliate Networks' },
                { link: `/Admin/AffiliateDetails/${apmId}?tab=2`, text: 'Affiliate Details' }
            ];
            breadCrumbList.push({ link: `/Admin/Brand/${merchant.id}?m=${mapmId}&a=${apmId}`, text: `${merchant.name}` });
        } else {
            breadCrumbList = [ ...this.state.breadCrumbList ];
            breadCrumbList.push({ link: `/Admin/Brand/${merchant.id}`, text: `${merchant.name}` });
        }

        this.merchantName = { ...merchant }.name;
        this.setState({ breadCrumbList, merchant });

        await this.getSectors();

        let apms = await getRequest(`api/AffiliateProgramManager/GetMerchantAffiliateProgamManagersByHostname?hostname=${merchant.hostname}&showAll=true&includeDeleted=true`);
        this.setState({ affiliateProgramManagers: apms, loading: false });
    }

    getSectors = async () => {
        let sectors = await getRequest('/api/Sector/GetSectors');
        sectors = sectors.sort((a, b) => { if (a.name < b.name) return -1; });
        let merchantSectors = await getRequest(`/api/Sector/GetMerchantSectors/?id=${this.state.merchant.id}`);

        for (var i = 0; i < merchantSectors.length; ++i) {
            for (var j = 0; j < sectors.length; ++j) {
                if (merchantSectors[i].sectorId === sectors[j].sectorId) {
                    sectors[j].active = true;
                    break;
                }
            }
        }

        this.setState({ sectors, filteredSectors: sectors });
    }

    isDataUrl = (s) => /^\s*data:/i.test(s || "");
    enforceLogoUrl = (next) => (this.isDataUrl(next) ? next : (next || "").slice(0, 255));

    handleLogoUrlChange = (e) => {
        const v = e.target.value ?? "";
        const next = this.enforceLogoUrl(v);
        this.setState((prev) => ({
            merchant: { ...prev.merchant, logoUrl: next },
            logoUrlError: !this.isDataUrl(next) && v.length > 255 ? "Max 255 characters for non-data URLs." : ""
        }));
    };

    handleLogoBeforeInput = (e) => {
        const el = this.logoInputRef.current;
        if (!el) return;

        const data = e.data ?? "";
        const prev = this.state.merchant.logoUrl ?? "";
        const start = el.selectionStart ?? prev.length;
        const end = el.selectionEnd ?? prev.length;
        const next = prev.slice(0, start) + data + prev.slice(end);

        if (!this.isDataUrl(next) && next.length > 255) {
            e.preventDefault();
            const room = 255 - (prev.length - (end - start));
            const piece = room > 0 ? data.slice(0, room) : "";
            const composed = prev.slice(0, start) + piece + prev.slice(end);
            this.setState(
                (p) => ({
                    merchant: { ...p.merchant, logoUrl: composed },
                    logoUrlError: "Max 255 characters for non-data URLs."
                }),
                () => {
                    const pos = start + piece.length;
                    el.setSelectionRange(pos, pos);
                }
            );
        } else {
            // clear error if we're back under the limit
            if (!this.isDataUrl(next) && next.length <= 255 && this.state.logoUrlError) {
                this.setState({ logoUrlError: "" });
            }
        }
    };

    handleLogoUrlPaste = (e) => {
        const text = (e.clipboardData?.getData("text") ?? "").trim();
        const el = this.logoInputRef.current;
        const prev = this.state.merchant.logoUrl ?? "";
        const start = el?.selectionStart ?? prev.length;
        const end = el?.selectionEnd ?? prev.length;
        const nextRaw = prev.slice(0, start) + text + prev.slice(end);

        e.preventDefault(); // insert exactly what we allow
        const next = this.enforceLogoUrl(nextRaw);

        this.setState(
            (p) => ({
                merchant: { ...p.merchant, logoUrl: next },
                logoUrlError: !this.isDataUrl(text) && nextRaw.length > 255 ? "Max 255 characters for non-data URLs." : ""
            }),
            () => {
                if (el) {
                    const insertedLen = next.length - (prev.length - (end - start));
                    const pos = start + Math.max(insertedLen, 0);
                    el.setSelectionRange(pos, pos);
                }
            }
        );
    };

    mapMerchantFields = () => {
        let fields = [
            { name: "name", title: "Name" },
            { name: "hostname", title: "Hostname" },
            { name: "hostname2", title: "Product Feed Hostname" },
            { name: "homepage", title: "Homepage" },
            { name: "logoUrl", title: "Logo URL" },
            { name: "productUrlRegex", title: "Product URL Regex" },
            { name: "contactFirstName", title: "First Name" },
            { name: "contactLastName", title: "Last Name" },
            { name: "contactEmail", title: "Email" },
            { name: "contactPhone", title: "Phone" },
            { name: "isAgencyManaged", title: "Agency Managed"},
            { name: "info", title: "Brand Information" },
            { name: "ordinal", title: "Preferred Order (set to 0 to delete preferred status)", inputType: "number", min: 0 },
            { name: "integrated", title: "Integrated" },
            { name: "deepLinkOnly", title: "Deep Link Only" },
            { name: "approvedCreatorsOnly", title: "Approved Creators Only" },
            { name: "manualProductCreation", title: "Manual Product Creation" },
            { name: "shareSubdomain", title: "Share Subdomain" },
            { name: "productUrlLookupStrategyId", title: "Product URL Lookup Strategy", inputType: "number" },
            { name: "brandPresent", title: "Brand Present" }
        ];

        return fields.map((field, i) => {
            return (
                <FormGroup key={i} className="form-group">
                    <p className={`${field.name === "contactFirstName" ? "mt-5" : ""}`} style={{ display: field.name === "contactFirstName" ? "" : "none", fontSize: "20px" }}>Contact Info</p>
                    <Label>{field.title}</Label>
                    {field.name === "homepage" ? (
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" style={{ backgroundColor: "lightgray" }}>https://</span>
                            </div>
                            <Input
                                className="form-control"
                                name={field.name}
                                onChange={(e) => this.onInputChange(e)}
                                value={this.state.merchant[field.name] ?? ""}
                            />
                        </div>
                    ) : (
                        <>
                            {field.name === "integrated" || field.name === "brandPresent" || field.name === "approvedCreatorsOnly" || field.name === "manualProductCreation" || field.name === "deepLinkOnly" || field.name === "isAgencyManaged" ? (
                                <CustomInput
                                    className={`${field.name === "isAgencyManaged" ? "mb-5" : ""}`}
                                    id={field.name}
                                    type="switch"
                                    name={field.name}
                                    onChange={(e) => this.onInputChange(e)}
                                    checked={!!this.state.merchant[field.name]}
                                />
                            ) : field.name === "info" ? (
                                <Input
                                    type="textarea"
                                    rows={4}
                                    style={{ resize: "vertical", overflow: "auto", backgroundColor: "#e9ecef", width: "335px" }}
                                    name={field.name}
                                    onChange={(e) => this.onInputChange(e)}
                                    value={this.state.merchant[field.name] ?? ""}
                                />
                            ) : field.name === "logoUrl" ? (
                                <>
                                    <Input
                                        innerRef={this.logoInputRef}
                                        className="form-control"
                                        name={field.name}
                                        type={field.inputType || "text"}
                                        style={{ backgroundColor: "#e9ecef" }}
                                        value={this.state.merchant[field.name] ?? ""}      // keep controlled
                                        onChange={this.handleLogoUrlChange}
                                        onBeforeInput={this.handleLogoBeforeInput}
                                        onPaste={this.handleLogoUrlPaste}
                                        invalid={!!this.state.logoUrlError}
                                    />
                                    <FormFeedback>{this.state.logoUrlError}</FormFeedback>
                                </>
                            ): (
                                <Input
                                    className={`form-control`}
                                    name={field.name}
                                    onChange={(e) => this.onInputChange(e)}
                                    value={this.state.merchant[field.name] ?? ""}
                                    type={field.inputType || "text"}
                                    style={{ backgroundColor: "#e9ecef", width: field.name === "ordinal" ? "100px" : "" }}
                                    min={field.name === "ordinal" ? field.min : undefined}
                                    maxLength={["contactFirstName", "contactLastName", "contactEmail", "contactPhone"].includes(field.name) ? 255 : undefined}
                                />
                            )}
                            {field.name === "productUrlLookupStrategyId" ? (
                                <FormText>
                                    1: Shopify | 2: MerchantSpecific | 3: Https To Http | 4: Fleet Feet | 5: Sportsman's guide | 6: Add "WWW"
                                </FormText>
                            ) : (
                                <span></span>
                            )}
                        </>
                    )}
                </FormGroup>
            );
        });
    }

    onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        let merchant = this.state.merchant;

        if (name === "filter") {
            let filter = e.target.value;
            let filteredSectors = this.state.sectors.filter(sector => sector.name.toLowerCase().includes(filter.toLowerCase()));

            this.setState({ filter, filteredSectors });
        }
        if (name === "integrated") {
            merchant.integrated = !merchant.integrated;
            if (merchant.integrated) {
                merchant.integratedDate = new Date().toISOString();
            } else {
                merchant.integratedDate = this.state.oldIntegratedDate;
            }
            this.setState({ merchant });
        }
        else if (name === "deepLinkOnly") {
            if (!!(merchant.deepLinkOnly)) {
                merchant.deepLinkOnly = !merchant.deepLinkOnly;
            } else {
                merchant.deepLinkOnly = true;
            }
            this.setState({ merchant });
        }
        else if (name === "isAgencyManaged") {
            if (!!(merchant.isAgencyManaged)) {
                merchant.isAgencyManaged = !merchant.isAgencyManaged;
            } else {
                merchant.isAgencyManaged = true;
            }
            this.setState({ merchant });
        }
        else if (name === "brandPresent") {
            merchant.brandPresent = !merchant.brandPresent;
            this.setState({ merchant });
        }
        else if (name === "approvedCreatorsOnly") {
            merchant.approvedCreatorsOnly = !merchant.approvedCreatorsOnly;
            this.setState({ merchant });
        }
        else if (name === "manualProductCreation") {
            !(merchant.manualProductCreation) ? merchant.manualProductCreation = true : merchant.manualProductCreation = false;
            this.setState({ merchant });
        }
        else {
            merchant[name] = value;
            this.setState({ merchant });
        }
    };

    onSectorClick = async (name) => {
        let sectors = [...this.state.sectors];
        sectors.findIndex((s) => { return s.name === name });
        let i = sectors.findIndex((s) => { return s.name === name })
        sectors[i].active = !sectors[i].active;

        this.setState({ sectors, filteredSectors: sectors, filter: "" });
    }

    renderSectors = () => {
        return this.state.filteredSectors.map((sector, i) => {
            if (sector.active) {
                return <button key={i} className="btn d-flex align-items-center active" onClick={(e) => { e.preventDefault(); this.onSectorClick(sector.name) }}>{sector.name}</button>
            }
            return <button key={i} className="btn d-flex align-items-center" onClick={(e) => { e.preventDefault(); this.onSectorClick(sector.name) }}>{sector.name}</button>
        });

    }

    setIntegratedOff = () => {
        let merchant = this.state.merchant;
        merchant.integrated = false;
        this.setState({ merchant });
    }

    renderInterests = () => {
        return (
            <FormGroup className="form-group">
                <Label className="control-label">Interests</Label>
                <div className="search-block">
                    <div className="form-group position-relative mx-auto my-0">
                        <input type="search" id="gsearch" name="filter" value={this.state.filter} onChange={(e) => this.onInputChange(e)} placeholder="Search for interests..." />
                    </div>
                    <div className="tag-results-sm d-flex justify-content-center flex-wrap py-3">
                        {this.renderSectors()}
                    </div>
                </div>
            </FormGroup>
        );
    }

    renderAffiliateProgramManagers = () => {
        return this.state.affiliateProgramManagers.map((apm, i) => {
            return (
                <button key={i} className="btn d-flex align-items-center" disabled>
                    {apm.name} {apm.commission * 100}%
                </button>
            )
        })
    }

    updateSectors = async () => {
        let selectedSectorIds = this.state.sectors.filter(sector => sector.active === true).map((sector) => { return sector.sectorId });
        await postRequest(`/api/Sector/UpdateMerchantSectors/?id=${this.state.merchant.id}`, selectedSectorIds);
    }

    updateMerchant = async () => {
        const merchant = { ...this.state.merchant };

        if (!!(merchant.ordinal) && merchant.ordinal < 1) {
            merchant.ordinal = null;
        }

        if (merchant.hasOwnProperty('homepage') && !!(merchant.homepage?.trim()) && !merchant.homepage.startsWith("https://") && !merchant.homepage.startsWith("http://")) {
            merchant.homepage = "https://" + merchant.homepage.trim();
        }

        if (!!(merchant.shareSubdomain)) {
            merchant.shareSubdomain = merchant.shareSubdomain.trim();
        }

        await postRequest('/api/Merchant/UpdateMerchant', merchant);

        if (merchant.hasOwnProperty('homepage') && !!(merchant.homepage?.trim()) && merchant.homepage.startsWith("https://")) {
            merchant.homepage = merchant.homepage.substring("https://".length);
        }

        this.setState({ merchant });
    }

    onSubmit = async (e) => {
        e.preventDefault();
        this.setState({ isSaving: true });
        await this.updateMerchant();
        await this.updateSectors();
        this.setState({ isSaving: false });
    }

    showModal = (e, id) => {
        e.preventDefault();
        this.setState({ show: !this.state.show });
        this.setState({ apmId: id })
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    showSynchModal = (e) => {
        e.preventDefault();
        this.setState({ showSynch: !this.state.showSynch });
    };

    hideSynchMdoal = () => {
        this.setState({ showSynch: false });
    };

    onRefreshYes = (e, id) => {
        e.preventDefault();

        this.state.affiliateProgramManagers.forEach(managerObj => {
            const apmId = managerObj.affiliateProgramManagerId;
            const internalId = managerObj.internalId;
            
            if (id === apmId) {
                getRequest(`/api/Merchant/RefreshFeed/?affiliateProgramManagerId=${apmId}&internalId=${internalId}`);
            };
        });

        this.setState({ show: false })
    };

    onSynchYes = (e) => {
        e.preventDefault();

        this.synchMerchantProducts();

        this.setState({ showSynch: false })
    };

    render() {
        if (this.state.loading) {
            return <LoadSpinner />
        }

        return (
            <>
                <Modal isOpen={this.state.show}
                    style={
                        {
                            overlay: {
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: 9998,
                            },
                            content: {
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                border: '1px solid #ccc',
                                background: '#fff',
                                overflow: 'auto',
                                WebkitOverflowScrolling: 'touch',
                                borderRadius: '4px',
                                outline: 'none',
                                padding: '50px',
                                minWidth: '300px',
                                height: '550px',
                                zIndex: 1060,
                            }
                        }
                    }
                    onRequestClose={() => this.setState({ show: false })}
                >

                    <div className="d-flex flex-column justify-content-between">
                        <h1 style={{ marginTop: '20%',textAlign: "center", color: "#B73239" }}>WARNING</h1>

                        <div className="mx-0 my-4">
                            <p style={{ textAlign: "center", diplay: "block", fontSize: '0.9rem' }}>
                                NOT RECOMMENDED TO REFRESH FEED DURING PEAK TRAFFIC
                            </p>
                            <p style={{ textAlign: 'center', marginTop: "35px", fontWeight: "bold" }}>
                                Do you wish to continue?
                            </p>
                        </div>
                    
                        <div className="d-flex justify-content-center gap-3">
                            <button type="button" className="btn btn-primary mr-2" onClick={(e) => this.onRefreshYes(e, this.state.apmId)}>Yes</button>
                            <button type="button" className="btn btn-secondary ml-2" onClick={() => this.setState({ show: false })}>No</button>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.showSynch}
                    style={
                        {
                            overlay: {
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: 9998,
                            },
                            content: {
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                border: '1px solid #ccc',
                                background: '#fff',
                                overflow: 'auto',
                                WebkitOverflowScrolling: 'touch',
                                borderRadius: '4px',
                                outline: 'none',
                                padding: '50px',
                                minWidth: '300px',
                                height: '550px',
                                zIndex: 1060,
                            }
                        }
                    }
                    onRequestClose={() => this.setState({ show: false })}
                >

                    <div className="d-flex flex-column justify-content-between">
                        <h1 style={{ marginTop: '20%', textAlign: "center", color: "#B73239" }}>WARNING</h1>

                        <div className="mx-0 my-4">
                            <p style={{ textAlign: "center", diplay: "block", fontSize: '0.9rem' }}>
                                NOT RECOMMENDED TO SYNCH MERCHANT PRODUCTS DURING PEAK TRAFFIC
                            </p>
                            <p style={{ textAlign: 'center', marginTop: "35px", fontWeight: "bold" }}>
                                Do you wish to continue?
                            </p>
                        </div>

                        <div className="d-flex justify-content-center gap-3">
                            <button type="button" className="btn btn-primary mr-2" onClick={(e) => this.onSynchYes(e, this.state.apmId)}>Yes</button>
                            <button type="button" className="btn btn-secondary ml-2" onClick={() => this.setState({ showSynch: false })}>No</button>
                        </div>
                    </div>
                </Modal>
                <section>
                    <AccountBanner breadCrumbList={this.state.breadCrumbList}>
                        <h1 className="mb-4">{this.merchantName}</h1>
                        <p className="mb-0">Edit Merchant Partner details</p>
                    </AccountBanner>
                </section>
                <section className="gray-bg full-height">
                    <div className="container py-5">
                        <div className="col-12">
                            <Form>
                                {
                                    !!(this.state.merchant?.logoUrl) && this.state.merchant.logoUrl.length > 0 ?
                                        <div className="form-group upload-image">
                                            <div className="avatar-upload">
                                                <div className="avatar-preview" style={{ width: "300px", backgroundColor: "white", position: "relative" ,borderRadius: "revert", border: "revert" }}>
                                                    <div id="imagePreview" style={{ position: "absolute", left: "50%", transform: "translate(-50%, 0)", maxWidth: "250px", minWidth: "200px", backgroundSize: "contain", borderRadius: "revert", backgroundImage: 'url(' + (!!(this.state.merchant?.logoUrl) ? this.state.merchant.logoUrl : "") + ')' }}>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                        :
                                        <></>
                                }
                                {this.mapMerchantFields()}
                                {this.renderInterests()}

                                <BrandTable apm={this.state.affiliateProgramManagers} hostname={this.state.merchant.hostname} setIntegratedOff={this.setIntegratedOff} showModal={this.showModal} mapmId={this.state.mapmId} />
                                <div className="d-flex ml-3" style={{ gap: "15px" }}>
                                {
                                    this.state.merchant.hostname?.trim().length > 0 &&
                                    this.state.merchant.name?.trim().length > 0 &&
                                    this.state.merchant.homepage?.trim().length > 0 &&
                                    !this.state.logoUrlError?

                                        <ActionButton className="btn btn-primary"
                                            onClick={(e) => { this.onSubmit(e) }}
                                            isLoading={this.state.isSaving}
                                        >
                                            Submit
                                        </ActionButton>
                                        :
                                        <ActionButton className="btn btn-primary"
                                            onClick={(e) => { this.onSubmit(e) }}
                                            isLoading={this.state.isSaving}
                                            isDisabled={true}
                                        >
                                            Submit
                                            </ActionButton>
                                    }
                                    <ActionButton className="btn btn-secondary"
                                        onClick={this.showSynchModal}
                                        isLoading={this.state.synchMerchantProductsCalled}
                                    >
                                        Synch Merchant Products
                                    </ActionButton>
                                </div>
                            </Form>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default Brand;